import { render } from "./VpcPeerings.vue?vue&type=template&id=635a71ef&scoped=true"
import script from "./VpcPeerings.vue?vue&type=script&lang=js"
export * from "./VpcPeerings.vue?vue&type=script&lang=js"

import "./VpcPeerings.vue?vue&type=style&index=0&id=635a71ef&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635a71ef"]])

export default __exports__